import { crmApiInstance } from './client.js';

const api = crmApiInstance;

export const notOrderingApi = {
  /**
   * GET /api/leads/not-ordering
   * Admin: full list, auto-assigned by the nightly segmentation job.
   */
  getList: (params = {}) => api.get('/leads/not-ordering', { params }).then(r => r.data),

  /** POST /api/admin/not-ordering/:leadId/remove — pull a customer out of the Not Ordering bucket */
  remove: (leadId) => api.post(`/admin/not-ordering/${leadId}/remove`).then(r => r.data),

  /** GET /api/admin/not-ordering-column-values?field= — distinct values for a column-header filter */
  getColumnValues: (params = {}) => api.get('/admin/not-ordering-column-values', { params }).then(r => r.data),

  /** GET /api/admin/not-ordering-export — CSV of the list exactly as currently filtered/searched */
  exportList: (params = {}) =>
    api.get('/admin/not-ordering-export', { params, responseType: 'blob' }),
};
